import { useCallback } from 'react'
import { CustomApiResponseErrorHandler } from '../../../../../types/api-call-options-with-custom-error-handler'
import { onResponseError403 } from '../../../../../_utils/on-response-error-403'
import {
    BackToParentViewCallbackProps,
    useNotificationBuilderViewBackToParentViewCallback,
} from './use-notification-builder-view-back-to-parent-view-callback'

type CallbackProps = BackToParentViewCallbackProps & {
    onFetchError?: CustomApiResponseErrorHandler
}

export const useNotificationBuilderViewResourceFetchErrorCallback = (props: CallbackProps) => {
    const { onFetchError, ...backToParentViewCallbackProps } = props

    const goBackToParentView = useNotificationBuilderViewBackToParentViewCallback(backToParentViewCallbackProps)

    return useCallback<CustomApiResponseErrorHandler>(
        (error, defaultHandler) => {
            if (onFetchError) {
                return onFetchError(error, defaultHandler)
            }

            onResponseError403(() => {
                goBackToParentView()
            })(error, defaultHandler)
        },
        [onFetchError, goBackToParentView],
    )
}
